(() => {
  const catalog = document.querySelector('[data-kaw-catalog]');
  if (!catalog) return;

  const controller = new AbortController();
  const { signal } = controller;
  const controls = [...catalog.querySelectorAll('[data-kaw-metal]')];
  const cards = [...catalog.querySelectorAll('[data-kaw-id]')];
  const grid = catalog.querySelector('.kaw-home-catalog__grid');

  let pairs = {};
  try {
    pairs = JSON.parse(catalog.dataset.kawMatrix || '{}');
  } catch (error) {
    pairs = {};
  }

  const isDesktop = window.matchMedia('(min-width: 769px)');
  let selected = isDesktop.matches ? ['zn', 'zn'] : [];

  const paint = () => {
    controls.forEach((c) => {
      const on = selected.includes(c.dataset.kawMetal);
      c.classList.toggle('is-active', on);
      c.setAttribute('aria-pressed', String(on));
    });
  };

  const matchesFor = (a, b) => {
    const list = [].concat(pairs[`${a}+${b}`] || [], pairs[`${b}+${a}`] || []);
    return list.map(Number);
  };

  // Parity with the original: every click empties the grid first; matches only
  // reappear once two metals are selected, and only then does it scroll.
  const filter = () => {
    const ids = selected.length === 2 ? matchesFor(selected[0], selected[1]) : [];
    cards.forEach((card) => {
      card.classList.toggle('is-hidden', !ids.includes(Number(card.dataset.kawId)));
    });
    if (selected.length === 2 && grid) grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  controls.forEach((control) => {
    control.addEventListener(
      'click',
      () => {
        if (selected.length === 2) selected.shift();
        selected.push(control.dataset.kawMetal);
        paint();
        filter();
      },
      { signal }
    );
  });

  isDesktop.addEventListener(
    'change',
    (event) => {
      // Parity with the original: a breakpoint change never repaints tiles nor
      // resets the grid — entering desktop only adds ZN to whatever is marked.
      selected = event.matches ? ['zn', 'zn'] : [];
      if (event.matches) {
        controls.forEach((c) => {
          if (c.dataset.kawMetal === 'zn') {
            c.classList.add('is-active');
            c.setAttribute('aria-pressed', 'true');
          }
        });
      }
    },
    { signal }
  );

  paint();
  window.addEventListener('pagehide', () => controller.abort(), { signal });
})();
